const ConfirmationScreen = ({ prenom, onBack }) => {
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <div className="text-center animate-fade-in max-w-lg" data-testid="confirmation-screen">
        <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-8">
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
          Merci {prenom} !
        </h1>
        <p className="text-xl text-slate-300 mb-8">
          Nous vous rappelons sous 24h ouvrées.
        </p>

        <div className="bg-slate-800 rounded-xl p-6 mb-8">
          <p className="text-slate-400 mb-4">Une question ? Appelez-nous directement.</p>
          <a
            href="tel:+3264232850"
            className="inline-flex items-center gap-3 bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all"
            onClick={() => {
              if (window.dataLayer) {
                window.dataLayer.push({ event: 'click_call' });
              }
            }}
            data-testid="confirmation-call-btn"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            Appelez-nous maintenant
          </a>
        </div>

        <button
          onClick={onBack}
          className="text-amber-500 hover:text-amber-400 underline transition-colors"
          data-testid="back-to-home"
        >
          Retour à la page
        </button>
      </div>
    </div>
  );
};

export default ConfirmationScreen;
